/* eslint-disable no-mixed-operators */
import { DEVELOPMENT_SOURCE_METRIC } from 'constants/sources';
import { TraunchOption, ISource, SourceField } from './Source/types';

export function createTraunchOptions(numberOfElements: number): TraunchOption[] {
    const traunchOptions: TraunchOption[] = [];
    for (let i = 1; i <= numberOfElements; i++) {
        traunchOptions.push({ label: i.toString(), value: i });
    }
    return traunchOptions;
}

export const calculateAmountForLTC = (loanToCost: number, totalUses: number): number => totalUses * loanToCost;

export const updateSourceField = (sources: ISource[], id: string, field: SourceField, value: any, totalUses: number): ISource[] => sources.map(source => {
    if (source.id === id) {
        const updatedSource = { ...source, [field]: value };

        if (field === 'sourceTypeId') {
            const isDebtType = value && String(value).toLowerCase().includes('debt');
            updatedSource.calculateDebt = isDebtType ? updatedSource.calculateDebt || false : false;
            if (!isDebtType) {
                updatedSource.metricType = undefined;
            } else {
                updatedSource.metricType = DEVELOPMENT_SOURCE_METRIC.LTC;
            }
            updatedSource.loanToCost = undefined;
            updatedSource.loanToValue = undefined;
            updatedSource.debtYield = undefined;
        }

        // logic for Calculate toggle on debt sources
        if (field === 'calculateDebt') {
            if (value) {
                updatedSource.calculatedOn = 'metric_percentage';
            } else {
                updatedSource.calculatedOn = 'amount';
                updatedSource.metricType = DEVELOPMENT_SOURCE_METRIC.LTC;
            }
            updatedSource.metricType = DEVELOPMENT_SOURCE_METRIC.LTC;
        }

        // Recalculate amount for LTC
        if (updatedSource.calculateDebt && updatedSource.metricType === DEVELOPMENT_SOURCE_METRIC.LTC) {
            const loanToCost = updatedSource.loanToCost || 0;
            updatedSource.ltcAmount = String(calculateAmountForLTC(loanToCost, totalUses));
        }

        if (field === 'loanToCost') {
            updatedSource.ltcAmount = String(calculateAmountForLTC(value, totalUses));
        }

        return updatedSource;
    }
    return source;
});

export const removeSourceById = (sources: ISource[], id: string): ISource[] => sources.filter(source => source.id !== id);

export const addNewSource = (sources: ISource[]): ISource[] => {
    const newSource: ISource = {
        id: new Date().toString(),
        amount: 0,
        traunch: sources.length + 1,
        name: 'New source',
        sourceTypeId: '',
        type: '',
        calculateDebt: false,
        metricType: undefined,
        loanToCost: undefined,
        loanToValue: undefined,
        debtYield: undefined,
    };

    return [...sources, newSource];
};
